import React from "react";
import { inr, monthLabel } from "@/lib/ownerApi";

const H = ["Month", "Opening cash", "New", "Left", "Active", "Fees earned", "Collected", "Earned − collected (cum.)", "Salary entitlement", "Teacher paid", "Advances", "Expenses", "Cash movement", "Closing cash"];
const TONE = { actual: "", current: "bg-emerald-50/60", forecast: "bg-sky-50/50 text-stone-600 italic" };

export default function ProfitMonthly({ rows }) {
  return (
    <section className="space-y-2">
      <h4 className="font-semibold text-stone-800">June–April month by month</h4>
      <div className="overflow-x-auto rounded-xl border bg-white">
        <table className="w-full text-sm" data-testid="profit-monthly">
          <thead className="bg-stone-50 text-[11px] uppercase text-stone-500"><tr>{H.map((h) => <th key={h} className="px-3 py-2 text-right first:text-left whitespace-nowrap">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.month} className={`border-t ${TONE[m.status]}`} data-testid={`profit-month-${m.month}`}>
                <td className="px-3 py-1.5 font-semibold whitespace-nowrap">{monthLabel(m.month)}<span className="block text-[10px] font-normal uppercase text-stone-500">{m.status}</span></td>
                <td className="px-3 text-right">{inr(m.opening_cash)}</td>
                <td className="px-3 text-right">{m.new_admissions}</td><td className="px-3 text-right">{m.leaving}</td><td className="px-3 text-right">{m.active}</td>
                <td className="px-3 text-right">{inr(m.fees_earned)}</td><td className="px-3 text-right text-emerald-800">{inr(m.collected)}</td>
                <td className="px-3 text-right text-amber-800">{inr(m.outstanding_cum)}</td><td className="px-3 text-right">{inr(m.teacher_entitlement)}</td>
                <td className="px-3 text-right">{inr(m.teacher_paid)}</td><td className="px-3 text-right">{inr(m.advances)}</td>
                <td className="px-3 text-right">{inr(m.opex_actual + m.opex_estimate)}{m.opex_estimate ? <span className="block text-[10px] text-amber-700">{inr(m.opex_estimate)} estimate</span> : null}</td>
                <td className={`px-3 text-right ${m.cash_movement < 0 ? "text-red-700" : "text-emerald-800"}`}>{inr(m.cash_movement)}</td>
                <td className="px-3 text-right font-semibold">{inr(m.closing_cash)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-stone-500">Opening cash in June includes undated lump-sum collections from the annual batches. A negative "earned − collected" means fees were paid ahead of the teaching. Italic rows are forecasts.</p>
    </section>
  );
}
